import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/pure-plank/result_back.webp";

function Resultsplank() {
  return (
    <section
      className="resultsplank text_whitegreen back_black"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={5}
            xxl={5}
            className="offset-xl-7 offset-lg-6 offset-md-6"
          >
            <h2>What were the results?</h2>
            <p>
              The app was delivered after completion, and it far surpassed the
              expectations of the client. It also caught the eyes of the
              audience and got a better reception than we had hoped.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Resultsplank;
